module.exports = __webpack_public_path__ + "static/img/human-3.db076308.png";